<div class="content">
    <!-- <p>Can't create new vendor!</p> -->
    <h3>
        Vendor is inactive.Please activate vendor to give login access.<br>
        Please click on edit button and fill the details to get the vendor login credentials.
    </h3>
    <button mat-raised-button class="button" (click)="onNoClick()">Ok</button>
</div>